export const EXCEL_LINKS_FILENAME = "aicarma-links.xlsx";
export const EXCEL_LINKS_SHEET_NAME = "URLs";
